var zIndexDefaults = {
  panel: 10010,
  lightsout: 10009
};
var zIndexCalculator = function zIndexCalculator(type, order) {
  return zIndexDefaults[type] + (order - 1);
};
export default zIndexCalculator;